import React from 'react';
import { classSet } from '@umu/umu-dom';
import './index.scss';
interface IProps extends React.HTMLAttributes<HTMLDivElement> {
    styleScroll?: React.CSSProperties;
    isShowBorder?: boolean;
    scrollRef?: React.RefObject<HTMLDivElement>;
}
const CustomScrollBar = (props: IProps) => {
    const { styleScroll = {}, isShowBorder = false, scrollRef, onClick, onMouseDown } = props;
    return (
        <div
            className={classSet({
                'custom-scroll-bar-scroll-wrapper': true,
                'custom-scroll-bar-scroll-wrapper-border': isShowBorder,
            })}
            onClick={onClick}
            onMouseDown={onMouseDown}
        >
            <div
                style={{
                    ...styleScroll,
                }}
                ref={scrollRef}
                className="scroll-space"
            />
        </div>
    );
};
export { CustomScrollBar };
